import { Reveal, RevealWords } from "./Motion";
import { MonitorSmartphone, Code2, Target, Search, PenTool, LineChart } from "lucide-react";

const SERVICES = [
  {
    n: "01",
    title: "Webdesign",
    desc: "Individuelle, conversion-orientierte Designs, die deine Marke premium aussehen lassen, mobil bis Desktop.",
    icon: MonitorSmartphone,
    span: "md:col-span-3",
    feats: ["UX/UI", "Design-System", "Prototyping"],
  },
  {
    n: "02",
    title: "Google Ads",
    desc: "Performante Kampagnen mit messbarem ROAS. Wir bringen dich vor Kunden, die kaufen wollen.",
    icon: Target,
    span: "md:col-span-3",
    feats: ["Search", "Performance Max", "Tracking"],
  },
  {
    n: "03",
    title: "Webentwicklung",
    desc: "Schneller, sauberer Code. React, Headless & WordPress, gebaut für Speed und Skalierung.",
    icon: Code2,
    span: "md:col-span-2",
    feats: ["React", "CMS"],
  },
  {
    n: "04",
    title: "SEO",
    desc: "Nachhaltig sichtbar bei Google: technisch, inhaltlich und lokal optimiert.",
    icon: Search,
    span: "md:col-span-2",
    feats: ["Technik", "Local"],
  },
  {
    n: "05",
    title: "Branding & Content",
    desc: "Logo, Identität und Inhalte, die im Kopf bleiben und Vertrauen aufbauen.",
    icon: PenTool,
    span: "md:col-span-2",
    feats: ["Identity", "Content"],
  },
];

export default function Services() {
  return (
    <section id="leistungen" className="mx-auto max-w-[1360px] px-5 py-24 md:px-10 md:py-36">
      <div className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.2em] text-[#2c3bff]">/ Leistungen</p>
          <h2 className="max-w-2xl font-display text-4xl leading-[0.95] text-ink sm:text-5xl md:text-6xl">
            <RevealWords text="Alles für deinen digitalen Erfolg." />
          </h2>
        </div>
        <Reveal delay={0.2}>
          <p className="flex items-center gap-2 max-w-xs text-[#565149]">
            <LineChart className="h-5 w-5 text-[#2c3bff]" />
            Eine Agentur, ein Ansprechpartner, von der Idee bis zur laufenden Kampagne.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-6">
        {SERVICES.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.07} className={s.span}>
            <div
              data-testid={`service-card-${s.n}`}
              className="group relative flex h-full flex-col justify-between overflow-hidden rounded-2xl border border-black/10 bg-white p-7 transition-all duration-500 hover:-translate-y-1 hover:border-[#2c3bff]/40 hover:shadow-[0_24px_50px_-24px_rgba(44,59,255,0.4)] md:p-8"
            >
              <div>
                <div className="mb-10 flex items-start justify-between">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#f4f1ea] transition-colors duration-300 group-hover:bg-[#2c3bff]">
                    <s.icon className="h-6 w-6 text-ink transition-colors duration-300 group-hover:text-white" />
                  </div>
                  <span className="font-mono text-sm text-[#b8b1a3]">{s.n}</span>
                </div>
                <h3 className="mb-2 font-display text-2xl text-ink md:text-3xl">{s.title}</h3>
                <p className="text-[15px] leading-relaxed text-[#565149]">{s.desc}</p>
              </div>
              <div className="mt-6 flex flex-wrap gap-2">
                {s.feats.map((f) => (
                  <span
                    key={f}
                    className="rounded-full border border-black/10 px-3 py-1 font-mono text-[10px] uppercase tracking-wider text-[#4a453d]"
                  >
                    {f}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
